import React, { useContext, createContext } from "react";
import { Button } from "../Button";
import Icon from "@mdi/react";
import { mdiLock } from "@mdi/js";
import { SubscriptionContext } from "src/services/SubscriptionService";
import { getGameLeague } from "src/services/EventService";

export function UpgradeButton({
  game,
  style,
  className,
  children,
  source,
}: {
  game: any;
  style?: any;
  className?: string;
  children?: any;
  source: string;
}) {
  const ctx = useContext(SubscriptionContext);
  const { onUpgradeClickOverride, upgradeTextOverride } = useContext(UpgradeButtonBehaviorContext);
  const league = getGameLeague(game);
  const handler =
    onUpgradeClickOverride ||
    (() =>
      ctx.togglePricingModal({
        track: {
          page: window.location.href,
          sport: league.name,
          source,
          awayTeam: game?.awayTeam?.fullName,
          homeTeam: game?.homeTeam?.fullName,
          gameId: game?.id,
        },
        source,
      }));
  return (
    <Button className={className} style={style} onClick={handler}>
      <Icon style={{ marginRight: "5px", verticalAlign: "middle" }} path={mdiLock} size="14px" color="#fff" />
      <span style={{ verticalAlign: "middle" }}>{upgradeTextOverride || children || "Upgrade"}</span>
    </Button>
  );
}

export const UpgradeButtonBehaviorContext = createContext<UpgradeButtonBehavior>({});
UpgradeButtonBehaviorContext.displayName = "UpgradeButtonBehaviorContext";
interface UpgradeButtonBehavior {
  /** Typed as possibly undefined because if you use this without the associated provider, it will be */
  onUpgradeClickOverride?: () => void;
  /** Replaces the button text next to the lock icon */
  upgradeTextOverride?: string;
}
